<template>
  <w-vue-select
    class="payment-pack-picker"
    :model="model"
    :values="options"
    :placeholder="placeholder"
    :ajax="true"
    @search="search"
  />
</template>

<script>
import { components } from '@witkac/bootstrap4-components';
import { mapState } from 'vuex';

import { Errors } from '@/enums/errors.enum';
import { notificationsMixin } from '@/mixins/notifications';

// @vuese
// Picker paczek płatności
export default {
  components,
  mixins: [notificationsMixin],
  props: {
    // Model
    model: { type: Object, required: true },
    // Placeholder
    placeholder: { type: String, default: 'Stwórz nową paczkę' },
    // Identyfikator procedury
    procedureId: { type: Number, required: false }
  },
  computed: mapState({ options: state => state.paymentPack.list.map(pack => ({ text: pack.number, value: pack.id })) }),
  methods: {
    // @vuese
    // Wyszukuje paczki płatności
    search(search) {
      this.$store
        .dispatch('paymentPack/list', {
          procedureId: this.procedureId,
          structureIds: this.$store.state.auth.nodes.map(node => node.id),
          search,
          order: 'number',
          desc: false
        })
        .catch(err => this.notifyError(Errors.PAYMENT_PACK_CANNOT_LIST));
    }
  }
};
</script>
